import { IWindcavePaymentResult } from 'types';
import { getHeaderOptions, getHttpService } from './http-service';
import { IPolicyScanQuote } from './policy-scan-service';
import { getDeviceType } from 'helpers';

const httpClient = getHttpService();

export interface ICreateSubscriptionBody {
  paymentMethodId: string;
  priceId?: string;
  employerId?: string;
}

interface ITurnersPayment {
  paymentMethodId: string;
  amount: number;
  excess: number;
  term: number;
  coverCode: string;
  quoteRef: string;
}

interface IProvidentPayment {
  amount: number;
  address: string;
  quoteRef: string;
  paymentType: string;
  policyScanId: string;
  excess: number;
  insuredAmount: number;
  city: string;
  streetLine1: string;
  postCode: string;
  policyStartDate: string;
  voluntaryExcess?: string;
}
interface IVerifyProvidentPayment {
  paymentIntent: any;
  policyScanId: string;
  policyId: string;
  purchaseSessionId: string;
  quoteRef: string;
  underwritingOutcomeResponseId: string;
  optionId: string;
  deviceType: string;
}

export const createMonthlySubscription = (body: ICreateSubscriptionBody) => {
  return httpClient.post(`/pay`, body, {
    headers: getHeaderOptions(),
  });
};

export const payProtecta = (body: IPolicyScanQuote) => {
  return httpClient.post(`/pay/protecta`, body, {
    headers: getHeaderOptions(),
  });
};

export const payStar = (body: IPolicyScanQuote) => {
  return httpClient.post(`/pay/star`, body, {
    headers: getHeaderOptions(),
  });
};

export const verifyTransactionBySessionId = (
  sessionId: string,
  policyProvider: string,
) => {
  const policyProviderName = policyProvider || 'protecta';
  return httpClient.post(
    `/pay/${policyProviderName}/verify`,
    { sessionId, deviceType: getDeviceType() },
    {
      headers: getHeaderOptions(),
    },
  );
};

export const getNewPurchaseUrlBySessionId = (sessionId: string, providerName: string = "protecta") => {
  return httpClient.post<IWindcavePaymentResult>(
    `/pay/${providerName}/retry`,
    { sessionId },
    {
      headers: getHeaderOptions(),
    },
  );
};

export const createTurnersPaymentIntent = (body: ITurnersPayment) => {
  return httpClient.post('/pay/turners', body, {
    headers: getHeaderOptions(),
  });
};

export const createProvidentPaymentIntent = (body: IProvidentPayment) => {
  return httpClient.post('/pay/provident', body, {
    headers: getHeaderOptions(),
  });
};

export const verifyProvidentPaymentIntent = (body: IVerifyProvidentPayment) => {
  return httpClient.post('/pay/provident/verify', body, {
    headers: getHeaderOptions(),
  });
};
